import type { Xinglet } from '@xing-com/crate-xinglet';

import type { MatchingBannerProps } from './matching-banner';
import { MatchingBanner } from './matching-banner';

export default class LoMatchingBanner implements Xinglet {
  public getComponent(): React.ComponentType<MatchingBannerProps> {
    return (props): JSX.Element => <MatchingBanner {...props} />;
  }
}
